import styled from 'styled-components';

interface AspectRatioContainerProps {
    width: string;
}

export const AspectRatioContainer = styled.div<AspectRatioContainerProps>`
    width: ${(props) => props.width};
`;

interface AspectRatioWrapperProps {
    height: string;
}

export const AspectRatioWrapper = styled.div<AspectRatioWrapperProps>`
    position: relative;
    width: 100%;
    height: 0;
    padding-top: ${(props) => props.height};
`;

export const AspectRatioInner = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;
